import { Injectable } from '@angular/core';
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { environment } from '../../environments/environment';

/**
 * Thin singleton wrapper around the Supabase client. Auth only — this project
 * still uses Firebase for Storage. The client points at the Foundation user
 * pool (see environment.supabase).
 */
@Injectable({ providedIn: 'root' })
export class SupabaseService {
  readonly client: SupabaseClient = createClient(environment.supabase.url, environment.supabase.anonKey);
}
